import React, {Fragment} from 'react';

import {
    SimpleForm,
    Edit,
    Toolbar,
    SaveButton,
    TextInput,
    BooleanInput,
} from 'react-admin';

import Avatar from "@material-ui/core/Avatar";
import {Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";

import UserEditIcon from "./UserEditIcon";
import Container from "@material-ui/core/Container";

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));


const NameInput = (props) => {
    return (
        <TextInput
            label="Name"
            source="name"
            variant='outlined'
            disabled={true}
            fullWidth
        >
        </TextInput>);
}

const IsAdminInput = (props) => {
    return (
        <BooleanInput
            label="Admin"
            source="admin"
            variant='outlined'
        >
        </BooleanInput>);
}

const IsSupervisorInput = (props) => {
    return (
        <BooleanInput
            label="Supervisor"
            source="supervisor"
            variant='outlined'
        >
        </BooleanInput>);
}

const IsOperatorInput = (props) => {
    return (
        <BooleanInput
            label="Operator"
            source="operator"
            variant='outlined'
        >
        </BooleanInput>);
}


const Header = (props) => {
    const classes = useStyles();
    return (
        <div className={classes.paper}>
            <Avatar className={classes.avatar}>
                <UserEditIcon/>
            </Avatar>
            <Typography component="h1" variant="h5">
                User Permissions
            </Typography>
            <br/>
            <Typography component="h5">
                Change user permissions to allow access to different actions
            </Typography>
        </div>
    );
}


const PostEditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton/>
    </Toolbar>
);

const PostTitle = ({ record }) => {
    return <span>{record ? ` - ${record.name}`  : ''}</span>;
};


const FormContentsEdit = (props) => {
    return (
        <SimpleForm {...props} toolbar={<PostEditToolbar/>} redirect="list" >
            <NameInput/>
            <IsAdminInput/>
            <IsSupervisorInput/>
            <IsOperatorInput/>
        </SimpleForm>
    );
}


export const UserEditCommon = ({record, ...props}) => {
    const classes = useStyles();
    return (
        <Container component="main" maxWidth="xs">

            <Header></Header>
            <Edit title={<PostTitle/>}  {...props} >
                <FormContentsEdit {...props}/>
            </Edit>

        </Container>

    );
}

